const el = '#body'

export default el
